import { engineComponent } from "neo-common";
import { FrameTimerEventEmitter, FrameTimerEvents, CreateFrameTimer } from "../Utils/FrameTimer";
import { TimelineElement } from "../Components/Elements/Graphics/TimelineElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Attributes } from "../Utils/Attributes";

/**
 *
 */
@engineComponent(ComponentTypes.DisplayObject)
export class IdleElement extends TimelineElement {
    private _idleTimerEmitter: FrameTimerEventEmitter;
    private _idleTime: number;

    /**
     *
     * @returns {number}
     */
    /*get idleTime(): number
    {
        return this._idleTime;
    }*/

    /**
     *
     * @param value
     */
    /*set idleTime(value: number)
    {
        this._idleTime = value;
    }*/

    constructor() {
        super();

        this._idleTime = 240;

        this._idleTimerEmitter = CreateFrameTimer("idleTimer");
        this._idleTimerEmitter.on(FrameTimerEvents.Complete, this.playAnimation.bind(this));

        this.on(TimelineElement.AnimationComplete, this.start.bind(this));
    }

    /**
     *
     * @param node
     */
    createByNode(node: Element): void {
        super.createByNode(node);

        this._idleTime = Attributes.assignIntAttribute(node, "IdleTime", this._idleTime);
    }

    /**
     * Emit event after "idleTime"
     */
    start(): void {
        this._idleTimerEmitter.start(this._idleTime);
    }

    /**
     * Stop emitter and remove listener.
     */
    stop(): void {
        this._idleTimerEmitter.stop();
        this._idleTimerEmitter.off(FrameTimerEvents.Complete, this.playAnimation.bind(this));
    }

    /**
     *
     */
    playAnimation(): void {
        this.play();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/IdleElement.ts
 **/